"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdk = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const infrastructure_1 = require("./infrastructure");
const custom_configurations_1 = require("./infrastructure/custom-configurations");
const delete_partner_custom_filter_1 = require("./infrastructure/custom-configurations/delete-partner-custom-filter/delete-partner-custom-filter");
const get_default_filters_1 = require("./infrastructure/custom-configurations/get-default-filters/get-default-filters");
const dataset_1 = require("./infrastructure/dataset");
const sdk = (apiHost, config) => {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, { ...config, useHttpError: true });
    return {
        addVariantDatasetToPartnerCatalog: (0, dataset_1.addVariantDatasetToPartnerCatalog)(client),
        createDatasetProduct: (0, dataset_1.createDatasetProduct)(client),
        deleteCooperativeSuggestedProduct: (0, infrastructure_1.deleteCooperativeSuggestedProduct)(client),
        deleteDatasetProduct: (0, dataset_1.deleteDatasetProduct)(client),
        deletePartnerCustomFilter: (0, delete_partner_custom_filter_1.deletePartnerCustomFilter)(client),
        getAllCooperativeVariantsCsv: (0, infrastructure_1.getAllCooperativeVariantsCsv)(client),
        getAttributes: (0, infrastructure_1.getAttributes)(client),
        getBasicCooperativeVariants: (0, infrastructure_1.getBasicCooperativeVariants)(client),
        getCategories: (0, infrastructure_1.getCategories)(client),
        getCooperativeCatalogProduct: (0, infrastructure_1.getPartnerCatalogProduct)(client),
        getCooperativeImportReport: (0, infrastructure_1.getCooperativeImportReport)(client),
        getCooperativeImportReports: (0, infrastructure_1.getCooperativeImportReports)(client),
        getCooperativeLatestImportReport: (0, infrastructure_1.getCooperativeLatestImportReport)(client),
        getCooperativeProductsSummary: (0, infrastructure_1.getCooperativeProductsSummary)(client),
        getCooperativeProductsSummaryStream: (0, infrastructure_1.getCooperativeProductsSummaryStream)(client),
        getCooperativeZoneCharges: (0, infrastructure_1.getCooperativeZoneCharges)(client),
        getCrops: (0, infrastructure_1.getCrops)(client),
        getDatasetPartnerIndexingTask: (0, dataset_1.getDatasetPartnerIndexingTask)(client),
        getDatasetProduct: (0, dataset_1.getDatasetProduct)(client),
        getDatasetProducts: (0, dataset_1.getDatasetProducts)(client),
        getDefaultFilters: (0, get_default_filters_1.getDefaultFilters)(client),
        getOnePartnerCustomFilters: (0, custom_configurations_1.getOnePartnerCustomFilters)(client),
        getPartnerCatalogProducts: (0, infrastructure_1.getPartnerCatalogProducts)(client),
        getPartnerCustomFilters: (0, custom_configurations_1.getPartnerCustomFilters)(client),
        getPartnerProductsCsv: (0, infrastructure_1.getPartnerProductsCsv)(client),
        getProduct: (0, infrastructure_1.getProduct)(client),
        getProducts: (0, infrastructure_1.getProducts)(client),
        getProductsBySkus: (0, infrastructure_1.getProductsBySkus)(client),
        getProductsStream: (0, infrastructure_1.getProductsStream)(client),
        getProductsSummary: (0, infrastructure_1.getProductsSummary)(client),
        getProductsSummaryFull: (0, infrastructure_1.getProductsSummaryFull)(client),
        getProductsSummaryFullStream: (0, infrastructure_1.getProductsSummaryFullStream)(client),
        getProductsSummaryStream: (0, infrastructure_1.getProductsSummaryStream)(client),
        getRedirection: (0, infrastructure_1.getRedirection)(client),
        getSuppliers: (0, infrastructure_1.getSuppliers)(client),
        getUsages: (0, infrastructure_1.getUsages)(client),
        putCooperativeCatalog: (0, infrastructure_1.putCooperativeCatalog)(client),
        putCooperativeProduct: (0, infrastructure_1.putCooperativeProduct)(client),
        removeVariantDatasetFromPartnerCatalog: (0, dataset_1.removeVariantDatasetFromPartnerCatalog)(client),
        setLocale: (0, infrastructure_1.setLocale)(client),
        submitDatasetPartnerIndexing: (0, dataset_1.submitDatasetPartnerIndexing)(client),
        submitDatasetProductIndexing: (0, dataset_1.submitDatasetProductIndexing)(client),
        updateCooperativeProduct: (0, infrastructure_1.updateCooperativeProduct)(client),
        updateCooperativeSuggestedProducts: (0, infrastructure_1.updateCooperativeSuggestedProducts)(client),
        updateCooperativeVariant: (0, infrastructure_1.updateCooperativeVariant)(client),
        updatePartnerCustomFilters: (0, custom_configurations_1.updatePartnerCustomFilters)(client),
    };
};
exports.sdk = sdk;
